import { createApp } from "vue";
import App from "./App.vue";
import { router } from "./router";
import "./style.css";

const app = createApp(App);
app.use(router);

/**
 * Hay que esperar al router antes de montar.
 *
 * Las vistas se cargan en diferido, así que sin esto el primer render es un
 * RouterView vacío que luego se *reemplaza* — y Vue lo toma como transición de
 * entrada. La página arrancaría en `opacity: 0` y solo aparecería cuando corra
 * un frame de animación, dejando el tablero en blanco si la pestaña está al
 * fondo o estrangulada. Montando después de `isReady()`, el primer pintado ya
 * es la página de verdad y las transiciones aplican solo a navegaciones reales.
 */
void router.isReady().then(() => {
  app.mount("#app");
});
